import React, { useState } from 'react'
import { GetCbuResponse } from '../../../Api/CBU/models'
import { Button, Card } from 'react-bootstrap'
import { AiOutlineCopy, AiOutlineEdit } from 'react-icons/ai'
import { toast } from 'react-hot-toast'
import { EditCbuModal } from './EditCbuModal'

export const CbuInfo = ({ cbuData, getCbuInfo }: { cbuData: GetCbuResponse | null, getCbuInfo: () => void }) => {
    const [showEditModal, setShowEditModal] = useState(false)

    const handleCopy = (text: string) => {
        navigator.clipboard.writeText(text)
        toast.success('Copiado al portapapeles')
    }

    return (
        <div className='d-flex flex-column w-100'>
            {showEditModal && <EditCbuModal show={showEditModal} onHide={() => setShowEditModal(false)} cbuData={cbuData} getCbuInfo={getCbuInfo} />}
            <Card className='border-lowgray rounded-3'>
                <Card.Body>
                    <Card.Title className='mb-2 text-primary text-xs d-flex align-items-center gap-2'>
                        Información de CBU
                        <Button variant='outline-primary py-0'
                            className='d-flex align-items-center gap-2 text-xs'
                            onClick={() => {
                                setShowEditModal(true)
                            }}
                        >
                            <AiOutlineEdit />
                            Editar
                        </Button>
                    </Card.Title>
                    <hr />

                    {cbuData?.CBU && <Card.Text className='d-flex align-items-center gap-2'>
                        {cbuData?.CBU}
                        <Button variant='outline-primary py-0'
                            className='d-flex align-items-center gap-2 text-xs'
                            onClick={() => handleCopy(cbuData?.CBU || '')}>
                            <AiOutlineCopy />
                            Copiar
                        </Button>
                    </Card.Text>}

                    {cbuData?.alias && <Card.Text className='d-flex align-items-center gap-2'>
                        Alias: {cbuData?.alias}
                        <Button
                            variant='outline-primary py-0'
                            className='d-flex align-items-center gap-2 text-xs'
                            onClick={() => handleCopy(cbuData?.alias || '')}>
                            <AiOutlineCopy />
                            Copiar
                        </Button>
                    </Card.Text>}

                    {cbuData?.titular && <Card.Text className='d-flex align-items-center gap-2'>
                        Titular: {cbuData?.titular}
                        <Button variant='outline-primary py-0'
                            className='d-flex align-items-center gap-2 text-xs'
                            onClick={() => handleCopy(cbuData?.titular || '')}>
                            <AiOutlineCopy />
                            Copiar
                        </Button>
                    </Card.Text>}

                    {cbuData?.hour_limit && <Card.Text className='d-flex align-items-center gap-2'>
                        Hora limite: {cbuData?.hour_limit}
                    </Card.Text>}

                </Card.Body>
            </Card>
        </div>
    )
}
